import type { MessengerInstagramViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetInstagramViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerInstagramViewSettings>(() => {
    const { instagramChatUrl, uiSettings } = widgetSettings.value.channels[WebWidgetChannelType.INSTAGRAM]
    const { title, description, buttonText } = uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.INSTAGRAM],
      instagramChatUrl,
      title,
      description,
      buttonText,
      showQrCode: uiSettings.showQrCode,
    } satisfies MessengerInstagramViewSettings
  })
}
